import { create } from 'zustand';

export interface Toast {
  id: number;
  kind: 'info' | 'success' | 'error';
  text: string;
  action?: { label: string; run: () => void };
  ttl: number;
}

interface ToastState {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id' | 'ttl'> & { ttl?: number }) => void;
  dismiss: (id: number) => void;
}

let seq = 1;
export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = seq++;
    const toast: Toast = { ttl: 4000, ...t, id };
    set({ toasts: [...get().toasts.slice(-3), toast] });
    window.setTimeout(() => get().dismiss(id), toast.ttl);
  },
  dismiss: (id) => set({ toasts: get().toasts.filter((x) => x.id !== id) }),
}));

export const toast = (text: string, kind: Toast['kind'] = 'info') => useToasts.getState().push({ text, kind });
